module.exports = "<app-vcnavigation></app-vcnavigation>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"